import { createActions } from 'reduxsauce'
 
export const { Types, Creators } = createActions({
	fetchUser: ['user_id'],
  fetchUserSuccess: ['responseData'],
  fetchUserFailure: ['error'],

  updateUser: ['payload', 'history'],
  updateUserSuccess: ['responseData'],
  updateUserFailure: ['error'],

  saveUser: ['payload'],
  saveUserSuccess: ['responseData'],
  saveUserFailure: ['error'],

  saveUserDetails: ['payload'],

  clearState: null
  
}, {});
